<template>
  <div :class="rootClass">
    <div class="flex flex-wrap justify-center gap-x-3 gap-y-1">
      <span
        v-for="entry in entries"
        :key="entry.num"
        class="whitespace-nowrap"
      >
        <strong>{{ entry.num }}</strong> = {{ entry.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LikertScaleLegend',
  props: {
    /**
     * sectionEnd: after a stack of charts (My Results / Team).
     * belowChart: directly under a single chart preview (KSS, admin).
     */
    variant: {
      type: String,
      default: 'sectionEnd',
      validator: (v) => v === 'sectionEnd' || v === 'belowChart',
    },
  },
  computed: {
    rootClass() {
      const base = 'text-center text-sm sm:text-base text-gray-600';
      if (this.variant === 'belowChart') {
        return `mt-3 pt-3 border-t border-gray-200 shrink-0 ${base}`;
      }
      return `pt-2 border-t border-gray-200 ${base}`;
    },
    entries() {
      const keys = {
        1: 'SliderQuestion.datalistOptions.stronglyDisagree',
        2: 'SliderQuestion.datalistOptions.disagree',
        3: 'SliderQuestion.datalistOptions.indifferent',
        4: 'SliderQuestion.datalistOptions.agree',
        5: 'SliderQuestion.datalistOptions.stronglyAgree',
      };
      const locale = this.$i18n?.locale || 'en';
      const otherLocale = locale === 'de' ? 'en' : 'de';
      return [1, 2, 3, 4, 5].map((num) => {
        const primary = this.$t(keys[num]) || String(num);
        const secondary = this.labelInLocale(keys[num], otherLocale) || primary;
        const label = primary === secondary ? primary : `${primary} / ${secondary}`;
        return { num, label };
      });
    },
  },
  methods: {
    labelInLocale(key, loc) {
      const messages = this.$i18n?.getLocaleMessage?.(loc) || this.$i18n?.messages?.[loc];
      if (!messages || !key) return '';
      const value = key.split('.').reduce((obj, k) => obj?.[k], messages);
      return typeof value === 'string' ? value : (this.$t(key) || '');
    },
  },
};
</script>
